var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React from "react";
import PropTypes from "prop-types";
export default (function (ContextClass) {
  var PropertyName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "AppContext";
  var Context = React.createContext();

  var ContentWrapper = function (_React$Component) {
    _inherits(ContentWrapper, _React$Component);

    function ContentWrapper(props) {
      _classCallCheck(this, ContentWrapper);

      var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

      _this.state = {
        app: new ContextClass(function (appState) {
          _this.setState({
            app: appState
          });
        })
      };
      return _this;
    }

    ContentWrapper.prototype.render = function render() {
      return React.createElement(Context.Provider, {
        value: this.state
      }, this.props.children);
    };

    return ContentWrapper;
  }(React.Component);

  ContentWrapper.propTypes = process.env.NODE_ENV !== "production" ? {
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.object, PropTypes.arrayOf(PropTypes.element)])
  } : {};

  var withProvider = function withProvider(Component) {
    return function (props) {
      return React.createElement(ContentWrapper, null, React.createElement(Component, props));
    };
  };

  var consumeContext = function consumeContext(Component) {
    return function (props) {
      return React.createElement(Context.Consumer, null, function (context) {
        var _extends2;

        return React.createElement(Component, _extends({}, props, (_extends2 = {}, _extends2[PropertyName] = context.app, _extends2)));
      });
    };
  };

  return {
    withProvider: withProvider,
    consumeContext: consumeContext
  };
});